import { render, staticRenderFns } from "./Pesquisa.vue?vue&type=template&id=4f7debb4&scoped=true&"
import script from "./Pesquisa.vue?vue&type=script&lang=js&"
export * from "./Pesquisa.vue?vue&type=script&lang=js&"
import style0 from "./Pesquisa.vue?vue&type=style&index=0&id=4f7debb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7debb4",
  null
  
)

export default component.exports